<div>
  <mat-tab-group>
    <mat-tab label="Preparaciones">
      <div class="preparation-table-scroll">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="!loading" [innerHTML]="preparationHtml"></div>
      </div>
    </mat-tab>
    <mat-tab label="Procedimientos">
      <div class="preparation-table-scroll">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="!loading" [innerHTML]="procedureHtml"></div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="printAndClose()">
      Imprimir preparaciones
    </button>
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Salir
    </button>
  </div>
</div>
